<template>
  <div class="newscenterindex">
		<div class="contentTop">
			<banner></banner>
			<!-- <product></product> -->
			
			<div class="contentMiddle">
				<headerview></headerview>
				<div class="con_all">
					<div class="con_all_one">
						<tipsign :titleName="typeVal"></tipsign>
						<span>当前位置：{{typeVal}}</span>
					</div>
					
					<div class="con_all_two" v-show="typesign == 0 || typesign == 1 || typesign == 5 || typesign == 9">
						<div v-for="(item,index) in list" :key="index" class="listCar">
							<div class="imgCar">
								<img :src="$imgUrl + item.thumbnail_dictText" alt=""/> 
							</div>
							<div class="textCar">
								<div class="titleCar">
									<span class="title">{{item.title || ''}}</span>
									<span class="time">{{item.pubTime || ''}}</span>
								</div>
								<div class="conCar">
									{{gethypertext(item.hypertext)}}
								</div>
								<div class="tipCar">
									<span style="margin-right: 0.4rem;">作者：{{item.createBy_dictText || ''}}</span>
									<span style="margin-right: 0.4rem;">来源：{{item.source || ''}}</span>
									<span style="margin-right: 0.4rem;">阅读：{{item.viewCount || '0'}}次</span>
								</div>
								<div class="btnCar">
									<div class="btn" @click="toDetail(item)">
										查看详情
									</div>
								</div>
							</div>
						</div>
					</div>
						
					<div class="con_all_two" v-show="typesign == 2">
						<div v-for="(item,index) in list" :key="index" class="listCar">
							<div class="imgCar"> 
								<img :src="$imgUrl + item.thumbnail_dictText" alt=""/> 
							</div>
							<div class="textCar">
								<div class="titleCar">
									<span class="title">{{item.compilationTitle || ''}}</span>
									<span class="time">{{item.publishTime || ''}}</span>
								</div>
								<div class="conCar">
									{{gethypertext(item.compilationContent)}}
								</div>
								<div class="tipCar">
									<span style="margin-right: 0.4rem;">作者：{{item.createBy_dictText || ''}}</span>
									<span style="margin-right: 0.4rem;">来源：{{item.columnId_dictText || ''}}</span>
									<span style="margin-right: 0.4rem;">阅读：{{item.viewCount || '0'}}次</span>
								</div>
								<div class="btnCar">
									<div class="btn" @click="toDetail(item)">
										查看详情
									</div>
								</div>
							</div>
						</div>
					</div>
						
					<div class="con_all_two" v-show="typesign == 3">
						<div v-for="(item,index) in list" :key="index" class="listCar">
							<div class="imgCar">
								<img :src="$imgUrl + item.cover_dictText" alt=""/> 
							</div>
							<div class="textCar">
								<div class="titleCar">
									<span class="title">{{item.title || ''}}</span>
									<span class="time">{{item.submissionTime || ''}}</span>
								</div>
								<div class="conCar">
									{{gethypertext(item.hypertext)}}
								</div>
								<div class="tipCar">
									<span style="margin-right: 0.4rem;">作者：{{item.createBy_dictText || ''}}</span>
									<span style="margin-right: 0.4rem;">来源：{{item.outline?item.outline.substring(0,10):''}}</span>
									<span style="margin-right: 0.4rem;">阅读：{{item.viewCount || '0'}}次</span>
								</div>
								<div class="btnCar">
									<div class="btn" @click="toDetail(item)">
										查看详情
									</div>
								</div>
							</div>
						</div>
					</div>	
					
					<div class="con_all_two" v-show="typesign == 4">
						<div v-for="(item,index) in list" :key="index" class="listCar">
							<div class="imgCar"> 
								<img :src="$imgUrl + item.thumbnailResourceId_dictText" alt=""/> 
							</div>
							<div class="textCar">
								<div class="titleCar">
									<span class="title">{{item.title || ''}}</span>
									<span class="time">{{item.publishTime || ''}}</span>
								</div>
								<div class="conCar">
									<!-- {{item.content?item.content.substring(0,150):''}} -->
									{{gethypertext(item.content)}}
								</div>
								<div class="tipCar">
									<span style="margin-right: 0.4rem;">作者：{{item.author_dictText || ''}}</span>
									<span style="margin-right: 0.4rem;">来源：{{item.source || ''}}</span>
									<span style="margin-right: 0.4rem;">阅读：{{item.readNumber || '0'}}次</span>
								</div>
								<div class="btnCar">
									<div class="btn" @click="toDetail(item)">
										查看详情
									</div>
								</div>
							</div>
						</div>
					</div>
					
					<div class="con_all_two" v-show="typesign == 6">
						<div v-for="(item,index) in list" :key="index" class="listCar">
							<div class="imgCar"> 
								<img :src="$imgUrl + item.thumbnail_dictText" alt=""
								:style="flag == 1 || flag == 2?'width:1.3rem;height:1.8rem;':''"/> 
							</div>
							<div class="textCar">
								<div class="titleCar">
									<span class="title">{{item.title || ''}}</span>
									<span class="time">{{item.pubTime || ''}}</span>
								</div>
								<div class="conCar">
									{{gethypertext(item.hypertext)}}
								</div>
								<div class="tipCar">
									<span style="margin-right: 0.4rem;">作者：{{item.createBy_dictText || ''}}</span>
									<span style="margin-right: 0.4rem;">来源：{{item.source || ''}}</span>
									<span style="margin-right: 0.4rem;">阅读：{{item.viewCount || '0'}}次</span>
								</div>
								<div class="btnCar">
									<div class="btn" @click="toDetail(item)">
										查看详情
									</div>
								</div>
							</div>
						</div>
					</div>
					
					<!-- 公告通知 -->
					<div class="con_all_two" v-show="typesign == 7">
						<div v-for="(item,index) in list" :key="index" class="listCar_two" @click="toDetail(item)">
							<div class="topcar">
								<span class="topcar_left">{{item.titile || ''}}</span>
								<span class="topcar_right">{{item.sendTime || ''}}</span>
							</div>
							
							<div class="tipCar">
								<span style="margin-right: 0.4rem;">作者：{{item.createBy_dictText || ''}}</span>
								<!-- <span style="margin-right: 0.4rem;">来源：{{item.columnId_dictText || ''}}</span>
								<span style="margin-right: 0.4rem;">阅读：{{item.viewCount || '0'}}次</span> -->
							</div>
						</div>	
					</div>
					
					<!-- 红领巾小记者风采-->
					<div class="con_all_two" v-show="typesign == 8">
						<div v-for="(item,index) in list" :key="index" class="listCar_three">
							<div class="imgCar"> 
								<img :src="$imgUrl + item.avatar_dictText" alt=""/> 
							</div>
							<div class="textCar">
								<div class="titleCar">
									<span class="title">{{item.name}} {{item.gender_dictText}} {{item.post}}</span>
									<!-- <span class="time"></span> -->
									<!-- <span style="color: #E61F26;font-size: 0.14rem;">查看更多> </span> -->
								</div>
								<div class="conCar">
									{{gethypertext(item.awards) || ''}}
								</div>
								<div class="tipCar">
									<!-- <span style="margin-right: 0.4rem;">作者：{{item.createBy || ''}}</span>
									<span style="margin-right: 0.4rem;">来源：{{item.source || ''}}</span>
									<span style="margin-right: 0.4rem;">阅读：{{item.viewCount || '0'}}次</span> -->
								</div>
								<div class="btnCar">
									<div class="btn" @click="toDetail(item)">
										查看详情
									</div>
								</div>
							</div>
						</div>	
					</div>
					
					<!-- 知识汇编 -->
					<div class="con_all_two" v-show="typesign == 10">
						<div v-for="(item,index) in list" :key="index" class="listCar">
							<div class="imgCar"> 
								<img :src="$imgUrl + item.thumbnail_dictText" alt=""/> 
							</div>
							<div class="textCar">
								<div class="titleCar">
									<span class="title">{{item.compilationTitle || ''}}</span>
									<span class="time">{{item.publishTime || ''}}</span>
								</div>
								<div class="conCar">
									{{gethypertext(item.compilationContent)}}
								</div>
								<div class="tipCar">
									<span style="margin-right: 0.4rem;">作者：{{item.createBy_dictText || ''}}</span>
									<span style="margin-right: 0.4rem;">来源：{{item.outline == null ?'':item.outline.substring(0,12)}}</span>
									<span style="margin-right: 0.4rem;">阅读：{{item.viewCount || '0'}}次</span>
								</div>
								<div class="btnCar">
									<div class="btn" @click="toDetail(item)">
										查看详情
									</div>
								</div>
							</div>
						</div>
					</div>
					
					<!-- 少年队网络视频 -->
					<div class="con_all_two" v-show="typesign == 11">
						<div v-for="(item,index) in list" :key="index" class="listCar">
							<div class="imgCar"> 
								<img :src="$imgUrl + item.cover_dictText" alt=""/> 
							</div>
							<div class="textCar">
								<div class="titleCar">
									<span class="title">{{item.title || ''}}</span>
									<span class="time">{{item.createTime || ''}}</span>
								</div>
								<div class="conCar">
					
								</div>
								<div class="tipCar">
									<span style="margin-right: 0.4rem;">作者：{{item.createBy_dictText || ''}}</span>
									<span style="margin-right: 0.4rem;">来源：{{item.source || ''}}</span>
									<span style="margin-right: 0.4rem;">阅读：{{item.viewCount || '0'}}次</span>
								</div>
								<div class="btnCar">
									<div class="btn" @click="toVideoOnline(item)">
										查看详情
									</div>
								</div>
							</div>
						</div>
					</div>
					
					<!-- 文化产品 -->
					<div class="con_all_two" v-show="typesign == 12">
						<div v-for="(item,index) in list" :key="index" class="listCar">
							<div class="imgCar"> 
								<img :src="$imgUrl + item.picture_dictText" alt=""/> 
							</div>
							<div class="textCar">
								<div class="titleCar">
									<span class="title">{{item.title || ''}}</span>
									<span class="time">{{item.pubTime || ''}}</span>
								</div>
								<div class="conCar">
									{{gethypertext(item.introduction)}}
								</div>
								<div class="tipCar">
									<span style="margin-right: 0.4rem;">作者：{{item.createBy_dictText || ''}}</span>
									<span style="margin-right: 0.4rem;">来源：{{item.source || ''}}</span>
									<span style="margin-right: 0.4rem;">阅读：{{item.viewCount || '0'}}次</span>
								</div>
								<div class="btnCar">
									<div class="btn" @click="toDetail(item)">
										查看详情
									</div>
								</div>
							</div>
						</div>
					</div>
					
					<!-- 分页 -->
					<div class="con_all_three">
						<div is='footPage' class="zhini-pagination"
						  :currentPage="pageNo"
						  :totalPage="total"
						  @pageNum="pageNum"  :pagesize='pageSize'></div>
					</div>
					
				</div>
			</div>				
								
		<footview></footview>

  </div>
  
 </div> 
</template>

<script>
import tipsign from "../../../components/tipsign/tipsign.vue";
import footPage from '../../../components/footpage/footpage.vue'

export default {
  components: {
	 tipsign,
	 footPage,
  },
  
  data() {
		return {
			typesign:0,
			typeVal:"",
			flag:"",       //光荣榜标识
			
			list:[],
			pageNo:1,
			total:5,
			pageSize:5,
			
			ifsx:true,
			
		};
  },
  
  watch:{
		$route(){
		      this.typesign = this.$route.query.type
		},
	    typesign() {
		    this.$onScrollT()
	      	this.typesign = this.$route.query.type
			this.getList(this.typesign)
	    },
  },
  
  updated() {

  },
  
  mounted() {
		this.$onScrollT()		  
		console.log(this.$route.query.type)
		this.typesign = this.$route.query.type
		this.getList(this.typesign)
  },
  
  
  methods: {
	  //跳转详情
	  toDetail(item){
		    if(this.typesign == 6){
				this.$router.push({ path: '/pressrelease/detail', query: {id:item.id,type:this.typesign,flag:this.flag} });
				return;
			}
			this.$router.push({ path: '/pressrelease/detail', query: {id:item.id,type:this.typesign} });
	  },
	  
	  //跳转视频网络课程
	  toVideoOnline(item){
	  		   this.$router.push({ path: '/videoonlinecourse', query: {id:item.id}});
	  },
	  
	  //过滤富文本
	  gethypertext(str){
		  if(str == null){
		  		return "";
		  }
		  var str = str.replace(/<[^<>]+>/g, "").replace(/&nbsp;/gi, "").replace(/&rdquo;/gi, "")
		              .replace(/&ldquo;/gi, "").replace(/\n/gi, "").replace(/&hellip;/gi, "").replace(/&mdash;/gi, "");
		  str = str.substring(0,150);
		  return str;
	  },
	  
	  pageNum(e) {
			this.pageNo = e;
			this.getList(this.typesign);
			this.$onScrollT()
	  },
	  
	  //类型
	  getList(type){
	  		if(type == 0){
	  			this.typeVal='头条新闻';
	  			this.getHeadlines();
	  		}else if(type == 1){
	  			this.typeVal='校园情报站';
	  			this.getCampus();
	  		}else if(type == 2){
	  			this.typeVal='汇编文章';
	  			this.getNotice();
	  		}else if(type == 3){
	  			this.typeVal='专题活动';
	  			this.getSpecial();
	  		}else if(type == 4){
	  			this.typeVal='优秀作品播';
	  			this.getYpWorks();
	  		}else if(type == 5){
	  			this.typeVal='信息报送排行榜';
	  			this.getInformationsub();
	  		}else if(type == 6){
				this.typeVal='光荣榜';
				this.flag = this.$route.query.flag;
				this.getGlory();
			}else if(type == 7){
				this.typeVal='通知公告';
				this.getAnnountCement();
			}else if(type == 8){
				this.typeVal='红领巾小记者风采';
				this.getRedScarf();
			}else if(type == 9){
				this.typeVal='社会情报站';
				this.getSocial();
			}else if(type == 10){
				this.typeVal='知识汇编';
				this.getKnowledge()
			}else if(type == 11){
				this.typeVal='少年队网络视频';
				this.getYouthteam();
			}else if(type == 12){
				this.typeVal='文化产品';
				this.getCultural()
			}
	    
	  },
	  
	  //头条新闻
	  getHeadlines(){
			this.$get(`web/info/list?pageSize=5&pageNo=${this.pageNo}`).then(res=>{
				  if(res.success){
					    console.log(res)
						this.total=res.result.total
						this.list=res.result.records
				  }
			})
	  },
	  
	  //公告通知
	  getAnnountCement(){
			this.$get(`web/annountCement/list?pageSize=8&pageNo=${this.pageNo}`).then(res=>{
				  if(res.success){
						console.log(res)
						this.total=res.result.total - 3
						this.list=res.result.records
				  }
			})
	  },
	  
	  //校园情报站
	  getCampus(){
			this.$get(`web/info/campus?pageSize=5&pageNo=${this.pageNo}`).then(res=>{
				  if(res.success){
						this.total=res.result.total
						this.list=res.result.records
				  }
			})
	  },
	  
	  //汇编文章
	  getNotice(){
			this.$get(`web/compilation/ypCompilation/list?pageSize=5&pageNo=${this.pageNo}`).then(res=>{
				  if(res.success){
						this.total=res.result.total
						this.list=res.result.records
				  }
			})
	  },
	  
	  //专题活动
	  getSpecial(){
			this.$get(`web/informationsubmission/ypInformationSubmission/list?pageSize=5&pageNo=${this.pageNo}`).then(res=>{
				  if(res.success){
						this.total=res.result.total
						this.list=res.result.records
				  }
			})
	  },
	  
	  //优秀作品播
	  getYpWorks(){
			this.$get(`web/works/ypWorks/list?pageSize=5&pageNo=${this.pageNo}`).then(res=>{
				  if(res.success){
						this.total=res.result.total
						this.list=res.result.records
				  }
			})
	  },
	  
	  //信息报送排行榜
	  getInformationsub(){
			this.$get(`web/info/infoSubmit?flag=${this.flag}&pageSize=5&pageNo=${this.pageNo}`).then(res=>{
				  if(res.success){
						this.total = res.result.total
						this.list = res.result.records
				  }
			})
	  },
	  
	  //光荣榜
	  getGlory(){
			this.$get(`web/info/gloryList?flag=${this.flag}&pageSize=5&pageNo=${this.pageNo}`).then(res=>{
				  if(res.success){
						this.total = res.result.total
						this.list = res.result.records
				  }
			})
	  },
	  
	  //红领巾小记者风采
	  getRedScarf(){
			this.$get(`web/youngpioneers/ypYoungPioneers/list?pageSize=5&pageNo=${this.pageNo}`).then(res=>{
				  if(res.success){
						  this.total = res.result.total
						  this.list = res.result.records						
				  }
			})
	  },
	  
	  //社会情报站
	  getSocial(){
			this.$get(`web/info/society?pageSize=5&pageNo=${this.pageNo}`).then(res=>{
				  if(res.success){
						this.total = res.result.total
						this.list=res.result.records
				  }
			})
	  },
	  
	  //知识汇编
	  getKnowledge(){
			this.$get(`web/knowledgeCompilation/list?pageSize=5&pageNo=${this.pageNo}`).then(res=>{
				  if(res.success){
						this.total = res.result.total
						this.list = res.result.records
				  }
			})
	  },
	  
	  //少年队网络视频
	  getYouthteam(){
			this.$get(`web/teaching/list?pageSize=5&pageNo=${this.pageNo}`).then(res=>{
				  if(res.success){
						this.total = res.result.total
						this.list = res.result.records
				  }
			})
	  },
	  
	  //文化产品
	  getCultural(){
			this.$get(`web/culturalproduct/list?pageSize=5&pageNo=${this.pageNo}`).then(res=>{
				  if(res.success){
						this.total = res.result.total
						this.list = res.result.records
				  }
			})
	  },
	  
	  
  }
  
};
</script>

<style scoped lang="scss">
	::-webkit-scrollbar {
	    width: 0px;
	}
	.newscenterindex{
		.contentTop{
			// background-image: linear-gradient(#FFFFFF, #E98257);
		}
		
		.contentMiddle{
			padding-top: 1.7rem;
			height: 12.2rem;
			// border: 1px solid #FFFFFF;		
			.con_all{
				height: 10rem;	
				margin: 0.1rem auto;
				// margin-left: 4rem;
				// margin-right: 4rem;
				width: 12.15rem;
				background: #FFFFFF;
				.con_all_one{
					height: 0.4rem;
					line-height: 0.4rem;
					padding-left: 0.2rem;
					border-bottom: 0.01rem solid #ededed;
					display: flex;
					justify-content: space-between;
					span{
						font-size: 0.14rem;
						margin-right: 0.2rem;
					}
				}
				.con_all_two{
					height: 8rem;
					overflow-y:auto;
					// border: 1px solid red;
					.listCar{
						display: flex;
						height: 2.8rem;
						margin-right: 0.2rem;
						border-bottom: 0.01rem solid #ededed;
						align-items: center;
						.imgCar{
							width: 2.5rem;
							display: flex;
							align-items: center;
							justify-content: center;
							img{
								width: 2.3rem;
								height:1.8rem;
							}
						}
						.textCar{
							flex: 1;
							display: flex;
							flex-direction: column;
							.titleCar{
								height: 0.5rem;
								display: flex;
								align-items: center;
								justify-content: space-between;
								.title{
									font-weight: bold;
									font-size: 0.18rem;
								}
								.time{
									color: #999999;
									font-size: 0.14rem;
								}
							}
							.conCar{
								height: 0.8rem;
								color:#666666;
								font-size: 0.16rem;
							}
							.tipCar{
								color:#999999;
								height: 0.3rem;
								font-size: 0.14rem;
							}
							.btnCar{
								.btn{
									cursor: pointer;
									font-size: 0.16rem;
									width: 1.3rem;
									height: 0.35rem;
									line-height: 0.35rem;
								    background: #E61F26;
									border-radius: 0.03rem;
									color: #FFFFFF;
									font-weight: bold;
									text-align: center;								
								}
							}
						}
					}
					
					.listCar_two{
						cursor: pointer;
						margin-left: 0.2rem;
						margin-right: 0.2rem;
						border-bottom: 0.01rem solid #ededed;
						padding-top: 0.1rem;
						padding-bottom: 0.1rem;
						.topcar{
							height: 0.5rem;
							width: 100%;
							font-size: 0.18rem;
							display: flex;
							align-items: center;
							justify-content: space-between;
							.topcar_left{
								text-align: left;
							}
							.topcar_right{
								text-align: right;
								color: #999999;
							}
						}
						.tipCar{
							font-size: 0.14rem;
							color:#999999;
							height: 0.3rem;
						}
					}
					
					.listCar_three{
						display: flex;
						height: 2.8rem;
						margin-right: 0.2rem;
						border-bottom: 0.01rem solid #ededed;
						align-items: center;
						.imgCar{
							width: 2.5rem;
							display: flex;
							align-items: center;
							justify-content: center;
							img{
								width: 1.8rem;
								height:2.3rem;
							}
						}
						.textCar{
							flex: 1;
							display: flex;
							flex-direction: column;
							height: 2.2rem;
							.titleCar{
								height: 0.5rem;
								display: flex;
								align-items: center;
								justify-content: space-between;
								.title{
									font-weight: bold;
									font-size: 0.18rem;
								}
								.time{
									color: #999999;
									font-size: 0.14rem;
								}
							}
							.conCar{
								height: 0.8rem;
								color:#666666;
								font-size: 0.16rem;
							}
							.tipCar{
								color:#999999;
								height: 0.3rem;
								font-size: 0.14rem;
							}
							.btnCar{
								.btn{
									cursor: pointer;
									font-size: 0.16rem;
									width: 1.3rem;
									height: 0.35rem;
									line-height: 0.35rem;
								    background: #E61F26;
									border-radius: 0.03rem;
									color: #FFFFFF;
									font-weight: bold;
									text-align: center;								
								}
							}
						}
					}
					
					
				}
				
			}	
		}
			
			
		
		
	}
	
</style>
